import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'chameleon/ui-stack/ui/base/button';

const SelectClasses = (props) => {
  const {
    label,
    children,
    selectionBox,
    onButtonClick,
    hasClasses,
    items,
    selectedItems,
  } = props;
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    const itemIds = items.map(({ id }) => id);
    if (itemIds.length) {
      setAllSelected(
        itemIds.sort().toString() === selectedItems.sort().toString(),
      );
    }
  }, [items, selectedItems]);

  return (
    <div className="border-top border-b">
      <div className="h-16.8 px-4.6 flex justify-between items-center border-bottom">
        <h5 className="text-gray-700 text-14 uppercase m-0">{label}</h5>
        <Button
          isSecondary
          onClick={() => onButtonClick(allSelected)}
          disabled={!hasClasses}
        >
          {allSelected ? 'Unselect All' : 'Select All'}
        </Button>
      </div>
      {selectionBox}
      {children}
    </div>
  );
};

SelectClasses.propTypes = {
  label: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  selectionBox: PropTypes.element,
  hasClasses: PropTypes.bool,
  items: PropTypes.array,
  selectedItems: PropTypes.array,
  savedClasses: PropTypes.array,
};

SelectClasses.defaultProps = {
  selectionBox: <Fragment />,
  onButtonClick: () => {},
  hasClasses: false,
  items: [],
  selectedItems: [],
  savedClasses: [],
};

export default SelectClasses;
